'use strict';

var StrategyMqSpos = function StrategyMqSpos(strategyHelper) {
  function getLabel() {
    return 'All';
  }
  function getProfileLevel() {
    return 'MQ_SPOS';
  }
  function condition() {
    return true;
  }
  function profileMatched(quickFilterData, season, dowGroup) {
    return condition(quickFilterData, season, dowGroup);
  }
  function getFillData(quickFilterData, season, dowGroup) {
    return strategyHelper.getFillData(quickFilterData, season, dowGroup, condition);
  }
  return {
    getLabel: getLabel,
    getFillData: getFillData,
    profileMatched: profileMatched,
    getProfileLevel: getProfileLevel
  };
};
StrategyMqSpos.$inject = ['StrategyHelper'];
module.exports = StrategyMqSpos;